module.exports = new __parcel__URL__("geos-casa-gfed-cover.85410fe9.jpg").toString();